(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crycry-atelier"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crycry-atelier')) {
 customElements.define('crycry-atelier', class extends HTMLElement {
 connectedCallback() {
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  const track=this.querySelector('.cc-atelier__track');const videos=[...this.querySelectorAll('video')];const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sync=v=>{const b=v.closest('article').querySelector('.cc-atelier__toggle');b.textContent=v.paused?'▶':'Ⅱ';b.setAttribute('aria-label',v.paused?b.dataset.play:b.dataset.pause)};
  const load=v=>{if(v.dataset.loaded)return;v.querySelectorAll('source').forEach(s=>s.src=s.dataset.src);v.dataset.loaded='true';v.load()};
  const play=v=>{load(v);v.muted=true;v.play().catch(()=>sync(v))};
  const update=v=>{if(v.dataset.visible==='true'&&!document.hidden&&v.dataset.userPaused!=='true'&&(!reduced||v.dataset.userPlay==='true'))play(v);else v.pause()};
  this.observer=new IntersectionObserver(entries=>entries.forEach(e=>{const v=e.target;v.dataset.visible=String(e.isIntersecting&&e.intersectionRatio>=.55);update(v)}),{threshold:[0,.55]});
  videos.forEach(v=>{this.observer.observe(v);v.addEventListener('play',()=>sync(v),{signal});v.addEventListener('pause',()=>sync(v),{signal});v.closest('article').querySelector('button').addEventListener('click',()=>{if(v.paused){v.dataset.userPaused='false';v.dataset.userPlay='true';play(v)}else{v.dataset.userPaused='true';v.pause()}},{signal})});
  document.addEventListener('visibilitychange',()=>videos.forEach(update),{signal});
  let start=null,moved=false,blockedUntil=0;
  track.addEventListener('pointerdown',e=>{start={x:e.clientX,y:e.clientY};moved=false},{signal,passive:true});
  track.addEventListener('pointermove',e=>{if(start&&Math.hypot(e.clientX-start.x,e.clientY-start.y)>10){moved=true;blockedUntil=Date.now()+450}},{signal,passive:true});
  track.addEventListener('pointerup',()=>{if(moved)blockedUntil=Date.now()+450;start=null},{signal,passive:true});
  track.addEventListener('pointercancel',()=>{blockedUntil=Date.now()+450;start=null},{signal,passive:true});
  track.addEventListener('click',e=>{if(e.target.closest('a')&&e.detail!==0&&Date.now()<blockedUntil){e.preventDefault();e.stopPropagation()}},{signal,capture:true});
  track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  const arrows=[...this.querySelectorAll('[data-direction]')];
  const nav=()=>arrows.forEach(b=>b.disabled=b.dataset.direction==='-1'?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);
  arrows.forEach(b=>{b.setAttribute('aria-controls',track.id);b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.direction)*(track.querySelector('article')?.getBoundingClientRect().width+20||track.clientWidth),behavior:reduced?'instant':'smooth'}),{signal})});
  track.addEventListener('scroll',nav,{signal,passive:true});this.resize=new ResizeObserver(nav);this.resize.observe(track);nav();
  document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.cc-atelier__card');if(card&&this.contains(card))track.scrollTo({left:card.offsetLeft-track.firstElementChild.offsetLeft,behavior:'instant'})},{signal});
 }
 disconnectedCallback(){this.observer?.disconnect();this.resize?.disconnect();this.abort?.abort();this.querySelectorAll('video').forEach(v=>v.pause());this.ready=false}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crycry-petits-mots"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('crycry-petits-mots')) {
  customElements.define('crycry-petits-mots', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const listen = (el, type, handler) => el.addEventListener(type, handler, {signal});
      this.viewport = this.querySelector('.cpm__viewport');
      this.track = this.querySelector('.cpm__track');
      this.controls = this.querySelector('.cpm__controls');
      this.toggle = this.querySelector('.cpm__toggle');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.pauses = new Set();
      this.stopped = this.reduced.matches;
      this.busy = false;
      this.inView = false;
      this.dataset.ready = '';
      this.querySelectorAll('.cpm__card').forEach(card => {
        const dialog = card.querySelector('dialog');
        listen(card.querySelector('.cpm__read'), 'click', () => { this.pause('dialog'); dialog.showModal(); });
        listen(card.querySelector('.cpm__close'), 'click', () => dialog.close());
        listen(dialog, 'close', () => this.resume('dialog'));
        listen(dialog, 'click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
      });
      this.querySelectorAll('[data-direction]').forEach(button => listen(button, 'click', () => this.move(Number(button.dataset.direction))));
      listen(this.toggle, 'click', () => { this.stopped=!this.stopped; this.updateToggle(); this.schedule(); });
      listen(this, 'pointerenter', e => { if(e.pointerType!=='touch') this.pause('hover'); });
      listen(this, 'pointerleave', () => this.resume('hover'));
      listen(this, 'focusin', () => this.pause('focus'));
      listen(this, 'focusout', e => { if(!this.contains(e.relatedTarget)) this.resume('focus'); });
      listen(this.viewport, 'keydown', e => { if(e.target!==this.viewport) return; if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);} });
      listen(this.viewport, 'pointerdown', e => { if(e.target.closest('dialog')) return; this.startX=e.clientX; this.startY=e.clientY; this.pause('pointer'); });
      listen(window, 'pointerup', e => { if(this.startX!==undefined){ const dx=e.clientX-this.startX,dy=e.clientY-this.startY; if(Math.abs(dx)>35&&Math.abs(dx)>Math.abs(dy)){this.move(dx<0?1:-1);this.suppressClick=true;setTimeout(()=>this.suppressClick=false,0);} this.startX=undefined; this.resume('pointer');} });
      listen(window, 'pointercancel', () => {this.startX=undefined;this.resume('pointer');});
      this.viewport.addEventListener('click',e=>{if(this.suppressClick){e.preventDefault();e.stopPropagation();}},{capture:true,signal});
      listen(document, 'visibilitychange', () => {if(document.hidden)this.pause('hidden');else this.resume('hidden');});
      listen(this.reduced,'change',()=>{if(this.reduced.matches)this.stopped=true;this.updateToggle();this.schedule();});
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();},{threshold:.15});
      this.observer.observe(this);
      this.resize=new ResizeObserver(()=>{if(this.finishMove)this.finishMove();this.sync();this.schedule();});
      this.resize.observe(this.viewport);
      this.sync();this.updateToggle();
    }
    sync(){
      this.cols=Number(getComputedStyle(this).getPropertyValue('--cpm-cols'));
      const cards=Array.from(this.track.children);
      cards.forEach((card,index)=>{card.inert=index>=this.cols;card.setAttribute('aria-hidden',index>=this.cols?'true':'false');});
      this.controls.hidden=cards.length<=this.cols;
    }
    updateToggle(){this.toggle.textContent=this.stopped?this.toggle.dataset.play:this.toggle.dataset.pause;this.toggle.setAttribute('aria-pressed',String(this.stopped));}
    pause(reason){this.pauses.add(reason);clearTimeout(this.timer);}
    resume(reason){this.pauses.delete(reason);this.schedule();}
    schedule(){clearTimeout(this.timer);if(this.stopped||this.reduced.matches||this.pauses.size||!this.inView||document.hidden||this.busy||this.track.children.length<=this.cols)return;this.timer=setTimeout(()=>this.move(1),5000);}
    move(direction){
      if(this.busy||this.track.children.length<=this.cols||this.querySelector('dialog[open]'))return;
      clearTimeout(this.timer);this.busy=true;
      const first=this.track.firstElementChild;
      const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
      const duration=this.reduced.matches?0:450;
      this.track.style.transition='none';
      if(direction<0){this.track.prepend(this.track.lastElementChild);this.track.style.transform=`translateX(-${step}px)`;}
      this.track.getBoundingClientRect();
      this.track.style.transition=`transform ${duration}ms ease`;
      this.track.style.transform=direction>0?`translateX(-${step}px)`:'translateX(0)';
      let done=false;
      this.finishMove=()=>{if(done)return;done=true;clearTimeout(this.motionTimer);this.track.style.transition='none';if(direction>0)this.track.append(first);this.track.style.transform='translateX(0)';this.busy=false;this.finishMove=null;this.sync();this.schedule();};
      this.motionTimer=setTimeout(this.finishMove,duration+30);
    }
    disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.motionTimer);this.observer?.disconnect();this.resize?.disconnect();this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (window.matchMedia('(min-width: 750px)').matches && this.headerIsAlwaysSticky) this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky && !(this.dataset.crycryMobileHome === 'true')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky && !(this.dataset.crycryMobileHome === 'true')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky && !(this.dataset.crycryMobileHome === 'true')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
